(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('form[data-filters]').forEach((form) => {
    form.addEventListener('keydown', (event) => { if (event.key === 'Escape') { const detail = event.target.closest('details'); if (detail) { detail.open = false; detail.querySelector('summary').focus(); } } });
    form.addEventListener('change', () => {
      form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(() => {
  const states = new WeakMap();
  function init(details) {
    if (states.has(details) || typeof details.animate !== 'function') return;
    const summary = details.querySelector('summary');
    const content = details.querySelector(':scope > .rte, :scope > .size-guide__content');
    if (!summary || !content) return;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const events = new AbortController();
    const options = { signal: events.signal };
    let animation;
    let expanded = details.open;
    function cancel() {
      if (!animation) return;
      animation.onfinish = null;
      animation.cancel();
      animation = undefined;
    }
    function settle() {
      cancel();
      details.open = expanded;
      details.style.height = '';
      details.style.overflow = '';
      content.inert = false;
      summary.removeAttribute('aria-expanded');
    }
    summary.addEventListener('click', event => {
      if (event.defaultPrevented) return;
      event.preventDefault();
      const start = details.getBoundingClientRect().height;
      expanded = animation ? !expanded : !details.open;
      cancel();
      if (motion.matches) { settle(); return; }
      details.open = true;
      details.style.height = '';
      const end = expanded ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height;
      details.style.height = `${start}px`;
      details.style.overflow = 'hidden';
      content.inert = !expanded;
      summary.setAttribute('aria-expanded', String(expanded));
      if (Math.abs(start - end) < 1) { settle(); return; }
      animation = details.animate(
        [{ height: `${start}px` }, { height: `${end}px` }],
        { duration: 260, easing: 'cubic-bezier(0.2, 0, 0, 1)', fill: 'forwards' }
      );
      animation.onfinish = settle;
    }, options);
    details.addEventListener('toggle', () => {
      if (!animation) expanded = details.open;
    }, options);
    motion.addEventListener('change', event => {
      if (event.matches) settle();
    }, options);
    window.addEventListener('resize', () => {
      if (animation) settle();
    }, options);
    const destroy = () => { settle(); events.abort(); states.delete(details); };
    states.set(details, destroy);
  }
  function start(scope) {
    if (scope.matches?.('.pdp__info, .size-guide')) init(scope);
    scope.querySelectorAll('.pdp__info, .size-guide').forEach(init);
  }
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.('.pdp__info, .size-guide')) states.get(event.target)?.();
    event.target.querySelectorAll('.pdp__info, .size-guide').forEach(details => states.get(details)?.());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), { once: true });
  else start(document);
})();

  } catch(e) { console.error(e); }
})();
})();
